let pagePathOffset = 0

export function getPagePathOffset(): number {
  try {
    if (pagePathOffset === 0) {
      pagePathOffset = typeof document !== 'undefined' ? document.URL.split('/').slice(0, 3).join('/').length : 0
    }

    return pagePathOffset
  } catch (err) {
    console.error(err)
    return 0
  }
}
